"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusType = void 0;
var StatusType;
(function (StatusType) {
    StatusType[StatusType["ACTIVE"] = 1] = "ACTIVE";
    StatusType[StatusType["INVITED"] = 2] = "INVITED";
    StatusType[StatusType["DISABLED"] = 3] = "DISABLED";
    StatusType[StatusType["PAUSED"] = 4] = "PAUSED";
    StatusType[StatusType["DELETED"] = 5] = "DELETED";
    StatusType[StatusType["SCHEDULED"] = 6] = "SCHEDULED";
    StatusType[StatusType["QUEUED"] = 7] = "QUEUED";
    StatusType[StatusType["DELIVERING"] = 8] = "DELIVERING";
    StatusType[StatusType["COMPLETED"] = 9] = "COMPLETED";
    StatusType[StatusType["FAILED"] = 10] = "FAILED";
    StatusType[StatusType["PASSWORD_RESET"] = 11] = "PASSWORD_RESET";
    StatusType[StatusType["CANCELLED"] = 12] = "CANCELLED";
    StatusType[StatusType["COMPLETED_WITH_FAILURES"] = 13] = "COMPLETED_WITH_FAILURES";
    StatusType[StatusType["DRAFT"] = 14] = "DRAFT";
    StatusType[StatusType["CANCELLING"] = 15] = "CANCELLING";
    StatusType[StatusType["SCHEDULING"] = 16] = "SCHEDULING";
})(StatusType = exports.StatusType || (exports.StatusType = {}));
//# sourceMappingURL=status-type.js.map